import { Container } from "@/components/layouts/container";
import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_dashboard")({
	beforeLoad: ({ context }) => {
		if (!context.auth.user) {
			throw redirect({
				to: "/login",
			});
		}
	},
	component: DashboardLayout,
});

function DashboardLayout() {
	return (
		<Container>
			<Outlet />
		</Container>
	);
}
